import React from 'react';
import { useHistory } from "react-router-dom";

export default function Logout() {
    const history = useHistory();

    const handleLogout = (e) => {
        e.preventDefault();
        localStorage.clear();
        sessionStorage.clear();

        // VERY important: replace history
        history.push("/Login", { replace: true });
    };

    return (
        <div className="submit-btn">
            <button type="submit" id="logoutBtn" onClick={handleLogout}>
                Logout
            </button>
        </div>
    );
}


// import React from 'react'
// import { useTranslation } from 'react-i18next';
// import { useHistory } from 'react-router-dom';

// export default function Logout() {
//   const history = useHistory()
//   const {t} = useTranslation()

//   // Function to log out and clear tokens
//   const handleLogout = () => {
//     localStorage.removeItem('AccessToken');
//     localStorage.removeItem('RefreshToken');
//     localStorage.removeItem('GuID')
//     history.push('/login')
//   };

//   const logout= () => {
//     localStorage.clear();
//     window.location.href='/'
//   }

//   return (
//     <div>
//       <button type="button" onClick={handleLogout} 
//       // style={{ marginRight: "10px" }}
//       style={{marginLeft:"90%"}}
//       >
//        {t('logout')}
//       </button>
//     </div>
//   )
// }
